import { FC, useEffect, useRef, useState } from "react";
import { ViewProps } from "../types";

export type WithImageResizeProps = {
  imageDimensions: {
    width: number;
    height: number;
  };
  imageRef: React.RefObject<HTMLImageElement>;
};

export const withImageResize =
  (View: FC<WithImageResizeProps>) => (props: ViewProps) => {
    const imageRef = useRef<HTMLImageElement | null>(null);
    const [imageDimensions, setImageDimensions] = useState({
      width: 0,
      height: 0,
    });

    useEffect(() => {
      const updateDimensions = () => {
        if (imageRef.current) {
          setImageDimensions({
            width: imageRef.current.offsetWidth,
            height: imageRef.current.offsetHeight,
          });
        }
      };

      // Update dimensions initially when the image loads
      const handleImageLoad = () => {
        updateDimensions();
      };

      const imgElement = imageRef.current;
      if (imgElement) {
        imgElement.addEventListener("load", handleImageLoad);
        // Check if the image is already loaded
        if (imgElement.complete) {
          handleImageLoad();
        }
      }

      window.addEventListener("resize", updateDimensions);

      return () => {
        window.removeEventListener("resize", updateDimensions);
        if (imgElement) {
          imgElement.removeEventListener("load", handleImageLoad);
        }
      };
    }, []);

    return (
      <View {...props} imageDimensions={imageDimensions} imageRef={imageRef} />
    );
  };
